import React, { Component } from 'react';

import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';

import styles from './ExamChart.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamChartInfo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 데이터
    const { chartData } = this.props;

    let infectionPercent = 0;
    if (chartData.target > 0) {
      infectionPercent = Number((chartData.infection / chartData.target * 100).toFixed(0));
      if (chartData.infection > 0 && infectionPercent === 0) {
        infectionPercent = 1;
      }
    }

    // 치료 사용 여부
    const isCure = 1 === chartData.examType && 2 === chartData.attachData.attachExamType ? true : false;
    // 피싱 유도 타입의 훈련 양식
    const isPhishing = 4 === chartData.examType ? true : false;
    // 다운로드 유형
    const isLinkAttach = 2 & chartData.linkAttach ? true : false;

    return (
      <div className={cx('chart-1', { large: chartData.target > 99999 })}>
        <div className={cx('chart-1-each')}>
          <div className={cx('title')}>
            <Image src="/img/exam/chart/each_target.png" />
            {defineMessages(formatMessage({ id: 'ExamSummaryItem_8', defaultMessage: '훈련 대상' }))}
          </div>
          <div className={cx('content brand-green')}>
            <span>{chartData.target}</span>
            <span className={cx('ea brand-green font-size-11')}>
              {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
            </span>
          </div>
        </div>
        <div className={cx('chart-1-each')}>
          <div className={cx('title')}>
            <Image src="/img/exam/chart/each_send.png" />
            {defineMessages(formatMessage({ id: 'ExamSummaryItem_10', defaultMessage: '메일 발송' }))}
          </div>
          <div className={cx('content')}>
            <span>{chartData.send}</span>
            <span className={cx('ea')}>
              {'/' + chartData.target}
              <span className={cx('font-size-11')}>
                {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
              </span>
            </span>
          </div>
        </div>
        <div className={cx('chart-1-each')}>
          <div className={cx('title')}>
            <Image src="/img/exam/chart/each_read.png" />
            {defineMessages(formatMessage({ id: 'ExamSummaryItem_12', defaultMessage: '메일 열람' }))}
          </div>
          <div className={cx('content')}>
            <span>{chartData.read}</span>
            <span className={cx('ea')}>
              {'/' + chartData.target}
              <span className={cx('font-size-11')}>
                {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
              </span>
            </span>
          </div>
        </div>
        {isLinkAttach ? (
          <div className={cx('chart-1-each')}>
            <div className={cx('title')}>
              <Image src="/img/exam/chart/each_down.png" />
              {defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
            </div>
            <div className={cx('content')}>
              <span>{chartData.download}</span>
              <span className={cx('ea')}>
                {'/' + chartData.target}
                <span className={cx('font-size-11')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </span>
              </span>
            </div>
          </div>
        ) : (
          <div />
        )}
        {isPhishing ? (
          <div className={cx('chart-1-each')}>
            <div className={cx('title')}>
              <Image src="/img/exam/chart/each_access.png" />
              {defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))}
            </div>
            <div className={cx('content')}>
              <span>{chartData.download}</span>
              <span className={cx('ea')}>
                {'/' + chartData.target}
                <span className={cx('font-size-11')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </span>
              </span>
            </div>
          </div>
        ) : (
          <div />
        )}
        {!isPhishing ? (
          <div className={cx('chart-1-each')}>
            <div className={cx('title')}>
              <Image src="/img/exam/chart/each_infection.png" />
              {defineMessages(formatMessage({ id: 'ExamSummaryItem_14', defaultMessage: '감염' }))}
            </div>
            <div className={cx('content')}>
              <span>{chartData.infection}</span>
              <span className={cx('ea')}>
                {'/' + chartData.target}
                <span className={cx('font-size-11')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </span>
              </span>
            </div>
          </div>
        ) : (
          <div />
        )}
        {isPhishing ? (
          <div className={cx('chart-1-each')}>
            <div className={cx('title')}>
              <Image src="/img/exam/chart/each_phishing.png" />
              {defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))}
            </div>
            <div className={cx('content')}>
              <span>{chartData.infection}</span>
              <span className={cx('ea')}>
                {'/' + chartData.target}
                <span className={cx('font-size-11')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </span>
              </span>
            </div>
          </div>
        ) : (
          <div />
        )}
        {isCure ? (
          <div className={cx('chart-1-each')}>
            <div className={cx('title')}>
              <Image src="/img/exam/chart/each_cure.png" />
              {defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))}
            </div>
            <div className={cx('content')}>
              <span>{chartData.cure}</span>
              <span className={cx('ea')}>
                {'/' + chartData.target}
                <span className={cx('font-size-11')}>
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </span>
              </span>
            </div>
          </div>
        ) : (
          <div />
        )}
        <div className={cx('infectionPer')}>
          <span className={cx('text')}>
            {isPhishing
              ? defineMessages(formatMessage({ id: 'CtExamTemplateList_1', defaultMessage: '유출율' }))
              : defineMessages(formatMessage({ id: 'ExamChart_2', defaultMessage: '감염율' }))}
          </span>
          <span className={cx('number')}>{infectionPercent}</span>
          <span>%</span>
        </div>
      </div>
    );
  }
}

export default injectIntl(ExamChartInfo);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamChartInfo.js